// Port of api/fuel/app/classes/controller/api/monty/hindex/track.php
import DB from 'offline/db'
import User from 'offline/model/user'
import HindexType from 'offline/model/hindex/type'
import HindexTrack from 'offline/model/hindex/track'
import { currentUser, invalid, payload, persist } from './shared'

export default function(params) {
	var user = currentUser(params)
	if (!user) return invalid()

	var track = HindexTrack.record({
		where: {
			hindex_id: parseInt(params.index, 10) || 0,
			user_id: user.get_id()
		}
	})

	if (track) return invalid()

	var type = HindexType.with_id(parseInt(params.index, 10) || 0)
	if (!type) return invalid()

	DB.run('INSERT INTO hindex_track (hindex_id, user_id, track_generated, track_hindex, track_concentration, track_bias, track_share, track_coverage, track_efficiency, track_plays) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?)', [
		type.get_id(),
		user.get_id(),
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0
	])

	DB.run('UPDATE user SET user_count_hindex_added = user_count_hindex_added + 1 WHERE user_id = ?', [user.get_id()])
	DB.run('UPDATE hindex_type SET hindex_users = hindex_users + 1 WHERE hindex_id = ?', [type.get_id()])

	var freshUser = User.with_id(user.get_id())
	return persist(payload(freshUser, type))
}
